import React, { useEffect } from "react";
import "./Blog.css";
import { useLanguage } from "../LanguageContext/LanguageContext";
import img1 from "../../images/1.1.png";
import img2 from "../../images/2.2.png";
import img3 from "../../images/3.3.png";
import img4 from "../../images/4.4.png";

const postsData = {
  ar: [
    {
      img: img1,
      title: "التوصيل اللحظي مع HK ISTANBUL",
      body: `تُحدث HK ISTANBUL فرقًا حقيقيًا في عالم الشحن والخدمات اللوجستية الحديثة:

• حلول توصيل سريعة
• تتبع الشحنات بشكل لحظي
• تنظيم ذكي لمسارات الشحن
• شحن دولي سريع وآمن
• خدمات شحن جوي وبحري وبري باحترافية عالية

لم يعد الشحن مجرد عملية لوجستية، بل أصبح انعكاسًا حقيقيًا لوعد العلامة التجارية تجاه عملائها.

فعندما تصل الشحنة بسرعة وأمان، لا يستلم العميل منتجًا فقط — بل يستلم الثقة والاحترافية والاعتمادية.`,
    },
    {
      img: img2,
      title: "HK ISTANBUL ومفهوم الشحن الحديث",
      body: `تقدم HK ISTANBUL مفهومًا حديثًا في عالم الشحن والخدمات اللوجستية، حيث لم تعد عملية التوصيل مجرد نقل للشحنات، بل أصبحت جزءًا أساسيًا من تجربة العميل وبناء ثقة العلامة التجارية.

• تتبع لحظي للشحنات
• تواصل سريع وفعال مع العملاء
• تنظيم ذكي لمسارات التوصيل
• تكامل سلس مع التجارة الإلكترونية
• خدمات شحن جوي وبحري وبري باحترافية عالية
• حلول شحن سريعة وآمنة للشركات والأفراد

تؤمن HK ISTANBUL أن النجاح الحقيقي يبدأ من كسب ثقة العملاء وتقديم تجربة متكاملة تعكس الاحترافية والجودة في كل شحنة.`,
    },
    {
      img: img3,
      title: "الأتمتة الذكية في خدمات الشحن",
      body: `مع التطور السريع في عالم التجارة الإلكترونية، أصبحت عمليات الشحن والتوصيل عنصرًا أساسيًا في تجربة العميل.

توفر HK ISTANBUL حلولًا متطورة تجعل عملية إدارة الطلبات أكثر سرعة وكفاءة من خلال:

• تحويل الطلبات بشكل منظم وسريع
• تحديث معلومات الشحن بشكل لحظي
• إمكانية تتبع الشحنات بسهولة ووضوح
• تقليل نسبة الأخطاء التشغيلية
• إدارة الطلبات بكفاءة أعلى
• توفير الوقت والجهد على فرق العمل
• تحسين تجربة العملاء وزيادة مستوى الثقة

تؤمن HK ISTANBUL أن تجربة التوصيل الاحترافية هي جزء من هوية العلامة التجارية.`,
    },
    {
      img: img4,
      title: "سرعة التوصيل وبناء الثقة",
      body: `في عالم التجارة الإلكترونية اليوم، لم تعد جودة المنتج أو سعره وحدهما ما يصنع الفرق الحقيقي، بل أصبحت سرعة الوصول إلى العملاء جزءًا أساسيًا من نجاح أي علامة تجارية.

تسعى HK ISTANBUL إلى تقديم تجربة شحن متكاملة من خلال:

• تسريع عمليات التوصيل بكفاءة عالية
• تحسين تجربة العملاء وزيادة مستوى الرضا
• تعزيز ثقة العملاء بالعلامة التجارية
• تقليل التأخير والأخطاء التشغيلية

تؤمن HK ISTANBUL أن تجربة التوصيل ليست مجرد خدمة لوجستية، بل جزء أساسي من نجاح العلامة التجارية واستمرار نموها بثقة واحترافية.`,
    },
  ],
  en: [
    {
      img: img1,
      title: "Instant Delivery with HK ISTANBUL",
      body: `HK ISTANBUL is making a real difference in the world of modern shipping and logistics:

• Fast delivery solutions
• Real-time shipment tracking
• Smart route optimization
• Fast and safe international shipping
• Air, sea, and road freight services with the highest professionalism

Shipping is no longer just a logistics process — it has become a true reflection of a brand's promise to its customers.

When a shipment arrives quickly and safely, the customer doesn't just receive a product — they receive trust, professionalism, and reliability.`,
    },
    {
      img: img2,
      title: "HK ISTANBUL and the Modern Shipping Concept",
      body: `HK ISTANBUL introduces a modern concept in the world of shipping and logistics, where delivery is no longer simply moving shipments — it has become an essential part of the customer experience and brand trust.

• Real-time shipment tracking
• Fast and effective communication with clients
• Smart delivery route planning to save time
• Seamless integration with e-commerce platforms
• Air, sea, and road freight with high professionalism
• Fast and safe shipping solutions for businesses and individuals

HK ISTANBUL believes that real success starts with earning customer trust and delivering a complete experience that reflects professionalism and quality in every shipment.`,
    },
    {
      img: img3,
      title: "Smart Automation in Shipping Services",
      body: `With the rapid growth of e-commerce, shipping and delivery operations have become a critical element of the customer experience.

HK ISTANBUL provides advanced solutions that make order management faster and more efficient through:

• Organized and rapid order processing
• Real-time shipping information updates
• Easy and clear shipment tracking
• Reduced operational errors
• Higher-efficiency order management
• Time and effort savings for work teams
• Improved customer experience and increased trust

HK ISTANBUL believes that a professional delivery experience is part of a brand's identity.`,
    },
    {
      img: img4,
      title: "Fast Delivery and Building Trust",
      body: `In today's e-commerce world, product quality and price alone no longer make the real difference — speed of reaching customers has become an essential part of any brand's success.

HK ISTANBUL strives to deliver a complete shipping experience through:

• Accelerating delivery operations with high efficiency
• Improving customer experience and satisfaction
• Strengthening customer trust in the brand
• Reducing delays and operational errors

HK ISTANBUL believes that the delivery experience is not just a logistics service — it is an essential part of a brand's success and continued growth with confidence and professionalism.`,
    },
  ],
};

function Blog() {
  const { lang, t } = useLanguage();
  const posts = postsData[lang] || postsData.en;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="blogPage">
      <div className="blogHero">
        <h1 className="blogHeroTitle">{t.blog}</h1>
        <div className="blogHeroBar" />
      </div>

      <div className="blogGrid">
        {posts.map((post, i) => (
          <div className="blogCard" key={i}>
            <div className="blogCardImgWrap">
              <img src={post.img} alt={post.title} className="blogCardImg" />
            </div>
            <div className="blogCardBody" dir={lang === "ar" ? "rtl" : "ltr"}>
              <h2 className="blogCardTitle">{post.title}</h2>
              <div className="blogCardText">
                {post.body.split("\n").map((line, j) =>
                  line === "" ? (
                    <br key={j} />
                  ) : line.startsWith("•") ? (
                    <p key={j} className="blogBullet">{line}</p>
                  ) : (
                    <p key={j}>{line}</p>
                  )
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Blog;
